//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// Dashboard
import Loyalty from "views/Dashboard/Loyalty/Loyalty";
import MyDashboard from "views/Dashboard/Dashboard/MyDashboard";
import Dashboard from "views/Dashboard/Dashboard/Dashboard";
import MyStatements from "views/Dashboard/Dashboard/MyStatements";

// AuthorizedMembers

import AuthorizedMembers from "views/Dashboard/AuthorizedMembers/AuthorizedMembers";

// Locations
import Locations from "views/Dashboard/Locations/Locations";
import ViewLocations from "views/Dashboard/Locations/ViewLocations";

// Report
import Report from "views/Dashboard/Report/Report";

// Settings
import Settings from "views/Dashboard/Settings/Settings";
import EditSettings from "views/Dashboard/Settings/EditSettings";

// MPC
import MPC from "views/Dashboard/MPC/MPC";
import MpcDetail from "views/Dashboard/MPC/MpcDetail";

// MPC Mass Update
import MpcMassUpdate from "views/Dashboard/MpcMassUpdate/MpcMassUpdate";

//Privilege
import Privilege from "views/Dashboard/Privilege/Privilege";
import ViewLoyaltyAccountShipto from "views/Dashboard/Privilege/ViewShipTo";

//OverWrite
import OverWrite from "views/Dashboard/PointsAdjustment/PointsAdjustment";
import ViewOverWrite from "views/Dashboard/PointsAdjustment/ViewDetails";

// Users
import CreateUsers from "views/Dashboard/Users/CreateUsers";
import UserConfirmation from "views/Dashboard/Users/UserConfirmation";

// Transactions
import Transactions from "views/Dashboard/Transactions/Transactions";
import ViewTransaction from "views/Dashboard/Transactions/ViewTransaction";

// Redeem
import Redeem from "views/Dashboard/Redeem/Redeem";
import RedeemConfirmation from "views/Dashboard/Redeem/RedeemConfirmation";

// ACH
import ImportData from "views/Dashboard/ImportData/ImportData";
// import InvalidImportData from "views/Dashboard/ImportData/InvalidImportData";

// MacMerch
import MaxMerch from "views/Dashboard/MaxMerch/MaxMerch";

// Approval
import Approval from "views/Dashboard/Approval/Approval";

//Components
import UploadSuccess from "components/UploadSuccess/UploadSuccess";
import EmailLogs from "views/Dashboard/EmailLogs/EmailLogs";

// Tier Assignment
import TierAssignment from "views/Dashboard/TierAssignment/TierAssignment";

// Promotion
import Promotion from "views/Dashboard/Promotion/Promotion";
import CreatePromotion from "views/Dashboard/Promotion/Create";
import ViewPromotion from "views/Dashboard/Promotion/View";
import Criteria from "views/Dashboard/Promotion/Criteria/Criteria";
import CreateCriteria from "views/Dashboard/Promotion/Criteria/Create";
import ViewCriteria from "views/Dashboard/Promotion/Criteria/View";
import Range from "views/Dashboard/Promotion/Range/Range";
import CreateRange from "views/Dashboard/Promotion/Range/Create";
import ViewRange from "views/Dashboard/Promotion/Range/View";
import CriteriaRule from "views/Dashboard/Promotion/CriteriaRule/CriteriaRule";
import UploadPromotionCriteriaStatus from "views/Dashboard/Promotion/Criteria/UploadPromotionCriteriaStatus";

// Audit
import AuditConfig from "views/Dashboard/Audit/AuditConfig";
import CreateAuditConfig from "views/Dashboard/Audit/Create";
import ViewAuditConfig from "views/Dashboard/Audit/View";

// User Details
import UserDetails from "views/Dashboard/UserDetails/UserDetails";

// Shipto Details
import ShiptoDetails from "views/Dashboard/ShiptoDetails/ShiptoDetails";

// Redemption
import Redemption from "views/Dashboard/Redemption/RedemptionDetails";
import RedemptionDetail from "views/Dashboard/Redemption/ViewRedemptionDetail";

// Loyalty Affiliation
import LoyaltyAffiliation from "views/Dashboard/LoyalttyAffiliation/LoyaltyAffiliation";

// Member Details
import MemberDetails from "views/Dashboard/MemberDetails/MemberDetails";
import Upload from "views/Dashboard/Promotion/Criteria/UploadPromotionCriteria";
import UploadFailed from "components/UploadFailed/UploadFailed";

// Loyalty Tier Audit
import LoyaltyTierAudit from "views/Dashboard/LoyaltyTierAudit/LoyaltyTierAudit";

// consentApproval
import ConsentApproval from "views/Dashboard/ConsentApproval/ConsentApproval";
import CreateNewAdmin from "views/Dashboard/CreateNewAdmin/CreateNewAdmin";
import CreateNewAdminDetail from "views/Dashboard/CreateNewAdmin/CreateNewAdminDetail";

// Screen
import Screen from "views/Dashboard/Screen/Screen";
import CreateScreen from "views/Dashboard/Screen/Create";
import ViewScreen from "views/Dashboard/Screen/View";

//Response
import Response from "views/Dashboard/Response/Response";
import CreateResponse from "views/Dashboard/Response/Create";
import ViewResponse from "views/Dashboard/Response/View";

//JobAuditLog
import ViewJobAuditLog from"views/Dashboard/JobAuditLog/View"
// Role
import Role from "views/Dashboard/Role/Role";
import CreateRole from "views/Dashboard/Role/Create";
import ViewRole from "views/Dashboard/Role/View";

// BenefitCode
import BenefitCode from "views/Dashboard/BenefitCode/BenefitCode";
import CreateBenefitCode from "views/Dashboard/BenefitCode/Create";
import ViewBenefitCode from "views/Dashboard/BenefitCode/View";

// DriveToThrive
import DriveToThrive from "views/Dashboard/DriveToThrive/DriveToThrive";

import DriveToThriveTab from "views/Dashboard/DriveToThrive/DriveToThriveTab";

import DormantAutomation from "views/Dashboard/DriveToThrive/DormanAutomation";



// KPI Reports
import KPIReports from "views/Dashboard/KPIReports/KPIReports";
// MasterBenefit
import ContractCode from "views/Dashboard/ContractCode/ContractCode";
import ContractCodeDetail from "views/Dashboard/ContractCode/ContractCodeDetail";

//tier range
import TierRange from "views/Dashboard/TierRatio/TierRange"
import TierRangeDetail from "views/Dashboard/TierRatio/TierRangeDetail";

//cronList
import CronList from "views/Dashboard/CronList/CronList";

//Email Templete
import EmailTemplete from "views/Dashboard/EmailTemplete/EmailTemplete";
import EmailTempleteDetail from "views/Dashboard/EmailTemplete/View"
// Unconsented Member Accounts
import UnconsentedMemberAccounts from "views/Dashboard/UnconsentedMemberAccounts/UnconsentedMemberAccounts"
import DeactivatedMemberAccounts from "views/Dashboard/UnconsentedMemberAccounts/DeactivatedMemberAccounts"

//product
import Product from "views/Dashboard/Product/Product";
import ProductDetail from "views/Dashboard/Product/ProductDetail";
import negativepoints from "views/Dashboard/NegativePoints/NegativePoints";
import negativedetail from "views/Dashboard/NegativePoints/NegativeDetail";


//negative points mail

// Manage Signature Accounts
import ManageSignatureAccounts from "views/Dashboard/ManageSignatureAccounts/ManageSignatureAccounts";

import ViewPlan from "views/Dashboard/ManageSignatureAccounts/ViewPlan";


import SignatureTab from "views/Dashboard/ManageSignatureAccounts/SignatureTab";

import StartupTab from "views/Dashboard/ManageStartupAccounts/StartupTab";



import ManageServicePlusAccounts from "views/Dashboard/ManageServicePlusAccounts/ManageServicePlusAccounts";

import ServiceplusTab from "views/Dashboard/ManageServicePlusAccounts/ServiceplusTab";


import ThriveBackDateAccounts from "views/Dashboard/ThriveBackDate/ThriveBackDate";


// Signature Audit 
import SignatureAudit from 'views/Dashboard/SignatureAudit/SignatureAudit';
import ServicePlusAudit from 'views/Dashboard/ServicePlusAudit/ServicePlusAudit';
import LoginAudit from "views/Dashboard/LoginAudit/LoginAudit";
import BilltoConfigurationDetail from "views/Dashboard/BilltoConfiguration/BilltoConfigurationDetail";
import BilltoConfiguration from "views/Dashboard/BilltoConfiguration/BilltoConfiguration";
import HSbPointsCorection from "views/Dashboard/HsbPointsCorrection/HsbPointsCorrection";
import HSbPointsCorectionDetail from "views/Dashboard/HsbPointsCorrection/HsbPointsCorrectionDetail";
import OnewebRestricted from "views/Dashboard/OnewebRestricted/Onewebrestricted";
import SignatureStatus from "components/SignatureStatus/SignatureStatus";
import ImportStatus from "components/ImportStatus/ImportStatus";
import DormantView from "views/Dashboard/Locations/DormantView";

//points Managemnet
import pointsManagementScreen from 'views/Dashboard/PointsManagement/pointsManagementScreen';
import DynamicBanner from 'views/Dashboard/BannerUploader/BannerUploader';
import BannerSetup from "views/Dashboard/BannerSetup/BannerSetup";
import pointsTransfer from "views/Dashboard/PointsTransfer/PointsTransfer";
import redirectionLinks from "views/Dashboard/RedirectionLinks/RedirectionLinks";
import CreateRedirection from "views/Dashboard/RedirectionLinks/Create";
import ViewRedirection from "views/Dashboard/RedirectionLinks/View";
import ThriveSignatureRequest from "views/Dashboard/ThriveSignatureRequest/ThriveSignatureRequest";
import ThriveServicePlusRequest from "views/Dashboard/ThriveServicePlusRequest/ThriveServicePlusRequest"
import AutoEmailTemplate from "views/Dashboard/AutoEmailTemplate/AutoEmailTemplate";
import gepredirectionLinks from "views/Dashboard/GepRedirectionLinks/GepRedirectionLinks";
import CreateGepRedirection from "views/Dashboard/GepRedirectionLinks/Create";
import ViewGepRedirection from "views/Dashboard/GepRedirectionLinks/View";
import TargetAccounts from "views/Dashboard/TargetBanner/TargetAccounts";
import GoogleAnalyst from 'views/Dashboard/GoogleAnalyst/GoogleAnalyst';

import SignatureEnrollments from "views/Dashboard/SignatureEnrollments/SignatureEnrollments";
import SignatureUnEnrollments from "views/Dashboard/SignatureUnEnrollments/SignatureUnEnrollments";
import ThriveStartUpEnrollments from "views/Dashboard/ThriveStartUpEnrollments/ThriveStartUpEnrollments";

import ManageStartupAccounts from "views/Dashboard/ManageStartupAccounts/ManageStartupAccounts";
import StartupUnEnrollments from "views/Dashboard/StartupUnEnrollments/StartupUnEnrollments";
import StartupAudit from 'views/Dashboard/StartupAudit/StartupAudit';
import UnlockShiptoManagement from 'views/Dashboard/UnlockShiptoManagement/UnlockShiptoManagement';
import EditShiptoPage from 'views/Dashboard/UnlockShiptoManagement/EditShiptoPage';
import create from 'views/Dashboard/UnlockShiptoManagement/create';
import createDetails from 'views/Dashboard/UnlockShiptoManagement/createDetails';
import UploadShipto from 'views/Dashboard/UnlockShiptoManagement/UploadShipto';
import UnlockShiptoUploadResult from 'views/Dashboard/UnlockShiptoManagement/UnlockShiptoUploadResult';
import MilestoneTracking from "views/Dashboard/MilestoneTracking/MilestoneTracking";
import MilestonePromotion from "views/Dashboard/MilestoneCriteria/MilestoneCriteria";
import milestoneCriteriaCreate from "views/Dashboard/MilestoneCriteria/MilestoneCriteriaCreate";
import milestoneCriteriaView from "views/Dashboard/MilestoneCriteria/MilestoneCriteriaView";
import StackingPromotion from "views/Dashboard/StackingPromotion/StackingPromotion";
import CreateStackingPromotion from "views/Dashboard/StackingPromotion/CreateStackingPromotion";

import EditStackingPromotion from "views/Dashboard/StackingPromotion/EditStackingPromotion";
import GrowthBonusDashboard from "views/Dashboard/MilestoneTracking/MilestoneTrackingView";
import PromotionTab from "views/Dashboard/Promotion/PromotionTab";

import UnlockCustomerView from "views/Dashboard/MilestoneTracking/UnlockCustomerView";
import ViewMyBenefitStatement from "views/Dashboard/BenefitStatement/BenefitStatement";
import PromoCodeCreation from "views/Dashboard/PromoCodeCreation/PromoCodeCreation";


import ThriveCampaign from "views/Dashboard/ThriveCampaign/ThriveCampaign";




let dashboardRoutes = [
  { path: "/dashboard/loyalty", name: "Loyalty", component: Loyalty },
  {
    path: "/dashboard/mydashboard",
    name: "My Dashboard",
    component: MyDashboard,
  },
  { path: "/dashboard/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/dashboard/statements", name: "My Statements", component: MyStatements },
  { path: "/dashboard/benefit-statement", name: "My Benefit Statements", component: ViewMyBenefitStatement },
  {
    path: "/dashboard/authorized-members",
    name: "AuthorizedMembers",
    component: AuthorizedMembers,
  },
  { path: "/dashboard/locations", name: "Locations", component: Locations },
  {
    path: "/dashboard/view-shipto",
    name: "View Locations",
    component: ViewLocations,
  },
  {
    path: "/dashboard/dormant-view",
    name: "Dormant View",
    component: DormantView,
  },
  { path: "/dashboard/privilege", name: "Privilege", component: Privilege },
  {
    path: "/dashboard/view-loyalty-account-shipto",
    name: "View Loyalty Account Shipto",
    component: ViewLoyaltyAccountShipto,
  },
  {
    path: "/dashboard/report",
    name: "Report",
    component: Report,
  },
  { path: "/dashboard/settings", name: "Settings", component: Settings },
  {
    path: "/dashboard/edit-settings",
    name: "Edit Settings",
    component: EditSettings,
  },
  {
    path: "/dashboard/mpc",
    name: "MPC",
    component: MPC,
  },
  {
    path: "/dashboard/mpcdetail",
    name: "Mpc Detail",
    component: MpcDetail,
  },
  {
    path: "/dashboard/product-exclusione-inclusion",
    name: "Product Exclusion / Inclusion",
    component: MpcMassUpdate,
  },
  { path: "/dashboard/overwrite", name: "Over Write", component: OverWrite },
  {
    path: "/dashboard/view-overwrite",
    name: "View Overwrite",
    component: ViewOverWrite,
  },
  {
    path: "/dashboard/ach-loyalty-points",
    name: "ImportData",
    component: ImportData,
  },
  // {
  //   path: "/dashboard/invalid-import-data",
  //   name: "Invalid Import Data",
  //   component: InvalidImportData,
  // },
  {
    path: "/dashboard/upload-success",
    name: "Upload Success",
    component: UploadSuccess,
  },
  {
    path: "/dashboard/create-users",
    name: "Create Users",
    component: CreateUsers,
  },
  {
    path: "/dashboard/user-confirmation",
    name: "User Confirmation",
    component: UserConfirmation,
  },
  {
    path: "/dashboard/transactions",
    name: "Transactions",
    component: Transactions,
  },
  {
    path: "/dashboard/view-transaction",
    name: "View Transaction",
    component: ViewTransaction,
  },
  { path: "/dashboard/redeem", name: "Redeem", component: Redeem },
  {
    path: "/dashboard/redeem-confirmation",
    name: "Redeem Confirmation",
    component: RedeemConfirmation,
  },
  // {
  //   path: "/dashboard/max-merch",
  //   name: "Max Merch",
  //   component: MaxMerch,
  // },
  {
    path: "/dashboard/approval",
    name: "Approval",
    component: Approval,
  },
  {
    path: "/dashboard/email-logs",
    name: "Email Logs",
    component: EmailLogs,
  },
  {
    path: "/dashboard/tier-assignment",
    name: "Tier Assignment",
    component: TierAssignment,
  },
  {
    path: "/dashboard/promotion",
    name: "Promotion",
    component: PromotionTab,
  },
  {
    path: "/dashboard/create-promotion",
    name: "Create Promotion",
    component: CreatePromotion,
  },
  {
    path: "/dashboard/view-promotion",
    name: "View Promotion",
    component: ViewPromotion,
  },
  {
    path: "/dashboard/criteria-rule",
    name: "Criteria Rule",
    component: CriteriaRule,
  },
  {
    path: "/dashboard/criteria",
    name: "Criteria",
    component: Criteria,
  },
  {
    path: "/dashboard/create-criteria",
    name: "Create Criteria",
    component: CreateCriteria,
  },
  {
    path: "/dashboard/upload-criteria",
    name: "Upload Criteria",
    component: Upload,
  },
  {
    path: "/dashboard/upload-criteria-status",
    name: "Upload Criteria Status",
    component: UploadPromotionCriteriaStatus,
  },
  {
    path: "/dashboard/view-criteria",
    name: "View Criteria",
    component: ViewCriteria,
  },
  {
    path: "/dashboard/range",
    name: "Range",
    component: Range,
  },
  {
    path: "/dashboard/create-range",
    name: "Create Range",
    component: CreateRange,
  },
  {
    path: "/dashboard/view-range",
    name: "View Range",
    component: ViewRange,
  },
  {
    path: "/dashboard/audit-config",
    name: "Audit Config",
    component: AuditConfig,
  },
  {
    path: "/dashboard/create-audit-config",
    name: "Create Audit Config",
    component: CreateAuditConfig,
  },
  {
    path: "/dashboard/view-audit-config",
    name: "View Audit Config",
    component: ViewAuditConfig,
  },
  {
    path: "/dashboard/user-details",
    name: "User Details",
    component: UserDetails,
  },
  {
    path: "/dashboard/shipto-details",
    name: "Shiipto Details",
    component: ShiptoDetails,
  },
  {
    path: "/dashboard/redemption-details",
    name: "RedemptionDetails",
    component: Redemption,
  },
  {
    path: "/dashboard/view-redemption-detail",
    name: "View RedemptionDetail",
    component: RedemptionDetail,
  },
  {
    path: "/dashboard/loyalty-affiliation",
    name: "Loyalty Affiliation",
    component: LoyaltyAffiliation,
  },
  {
    path: "/dashboard/member-details",
    name: "Member Details",
    component: MemberDetails,
  },
  {
    path: "/dashboard/loyalty-tier-audit",
    name: "Member Details",
    component: LoyaltyTierAudit,
  },
  {
    path: "/dashboard/ConsentApproval",
    name: "ConsentApproval",
    component: ConsentApproval,
  },
  {
    path: "/dashboard/upload-failed",
    name: "Upload Failed",
    component: UploadFailed,
  },

  {
    path: "/dashboard/signature-status",
    name: "Signature Status",
    component: SignatureStatus,
  },

  {
    path: "/dashboard/import-status",
    name: "Import Status",
    component: ImportStatus,
  },
  {
    path: "/dashboard/create-new-admin",
    name: "Create New Admin",
    component: CreateNewAdmin,
  },
  {
    path: "/dashboard/create-new-admin-detail",
    name: "Create New Admin Detail",
    component: CreateNewAdminDetail,
  },
  {
    path: "/dashboard/screen",
    name: "Screen",
    component: Screen,
  },
  {
    path: "/dashboard/response",
    name: "Response",
    component: Response,
  },
  {
    path: "/dashboard/create-screen",
    name: "Create Screen",
    component: CreateScreen,
  },
  {
    path: "/dashboard/create-response",
    name: "Create Response",
    component: CreateResponse,
  },
  {
    path: "/dashboard/view-screen",
    name: "View Screen",
    component: ViewScreen,
  },
  {
    path: "/dashboard/view-response",
    name: "View Response",
    component: ViewResponse,
  },
  {
    path: "/dashboard/view-job-audit-log",
    name: "View JobAuditLog",
    component: ViewJobAuditLog,
  },
  {
    path: "/dashboard/role",
    name: "Role",
    component: Role,
  },
  {
    path: "/dashboard/create-role",
    name: "Create Role",
    component: CreateRole,
  },
  {
    path: "/dashboard/view-role",
    name: "View Role",
    component: ViewRole,
  },
  {
    path: "/dashboard/benefit-code",
    name: "BenefitCode",
    component: BenefitCode,
  },
  {
    path: "/dashboard/create-benefit-code",
    name: "Create Benefit Code",
    component: CreateBenefitCode,
  },
  {
    path: "/dashboard/view-benefit-code",
    name: "View Benefit Code",
    component: ViewBenefitCode,
  },
  {
    path: "/dashboard/kpi-reports",
    name: "KPI Reports",
    component: KPIReports,
  },

  {   path: "/dashboard/dormant-automation",
     name: "Dormant Automation",
     component: DormantAutomation,
   },
  // {
  //   path: "/dashboard/drive-to-thrive",
  //   name: "Drive To Thrive",
  //   component: DriveToThrive,
  // },
   {
    path: "/dashboard/contract-code",
    name: "Contract Code",
    component: ContractCode,
  },
  {
    path: "/dashboard/contract-code-details",
    name: "Contract Code Detail",
    component: ContractCodeDetail,
  },
  {
    path: "/dashboard/tierrange",
    name: "Tier Range",
    component: TierRange,
  },
  {
    path: "/dashboard/tierrangedetail",
    name: "Tier Range Detail",
    component: TierRangeDetail,
  },

  {
    path: "/dashboard/negativedetail",
    name: "Negative Detail",
    component: negativedetail,
  },
  {
    path: "/dashboard/cronlist",
    name: "Cron List",
    component: CronList,
  },
  {
    path: "/dashboard/emailtemplate",
    name: "Email Template",
    component: EmailTemplete,
  }, 
 {
    path: "/dashboard/unconsented-member-accounts",
    name: "Unconsented Member Accounts",
    component: UnconsentedMemberAccounts,
  },
  {
    path: "/dashboard/deactivated-member-accounts",
    name: "Deactivated Member Accounts",
    component: DeactivatedMemberAccounts,
  },
  {
    path: "/dashboard/view-emailtemplate",
    name: "View Email Template",
    component: EmailTempleteDetail,
  },
  {
    path: "/dashboard/product",
    name: "Products",
    component: Product,
  },
  {
    path: "/dashboard/productdetail",
    name: "Product Detail",
    component: ProductDetail,
  },
  {
    path: "/dashboard/manage-signature-accounts",
    name: "Manage Signature Accounts",
    component: SignatureTab,
  },
  {
    path: "/dashboard/drive-to-thrive",
    name: "Drive To Thrive",
    component: DriveToThriveTab,
  },
  {
    path: "/dashboard/manage-service-plus-accounts",
    name: "Manage Service Plus Accounts",
    component: ServiceplusTab,
  },
  {
    path: "/dashboard/negativepoints",
    name: "Negative Points Details",
    component: negativepoints,
  },
  // {
  //   path: "/dashboard/audit-signature",
  //   name: "Audit Signature",
  //   component: SignatureAudit
  // },
  // {
  //   path: "/dashboard/audit-service-plus",
  //   name: "Audit Service Plus",
  //   component: ServicePlusAudit
  // },
  {
    path: "/dashboard/audit-login",
    name: "Audit Login",
    component: LoginAudit
  },
  {
    path: "/dashboard/billto-configuration",
    name: "Billto Configuration",
    component: BilltoConfiguration,
  },
  {
    path: "/dashboard/billto-configuration-detail",
    name: "Billto Configuration Detail",
    component: BilltoConfigurationDetail,
  },
  {
    path: "/dashboard/hsb-points-correction",
    name: "HSB Points Correction",
    component: HSbPointsCorection,
  },
  {
    path: "/dashboard/hsb-points-correction-detail",
    name: "HSB Points Correction Detail",
    component: HSbPointsCorectionDetail,
  },
  {
    path: "/dashboard/restricted-shipto",
    name: "Restricted Billto",
    component: OnewebRestricted,
  },
  {
    path: "/dashboard/thrive-backdate",
    name: "Thrive Rewards Backdate",
    component: ThriveBackDateAccounts,
  },
  {
    path: "/dashboard/points-management",
    name: "points Management Screen",
    component: pointsManagementScreen,
  },

  {
    path: "/dashboard/banner-setup",
    name: "Banner Setup",
    component: BannerSetup,
  },
   { path: "/dashboard/pointstransfer", name: "Points Transfer", component: pointsTransfer },

   { path: "/dashboard/redirectionlinks", name: "Redirection Links", component: redirectionLinks },
   {
    path: "/dashboard/create-redirection-links",
    name: "Create Redirection",
    component: CreateRedirection,
  },

  {
    path: "/dashboard/view-redirection",
    name: "View Redirection",
    component: ViewRedirection,
  },

  // {
  //   path: "/dashboard/thrive-service-plus-request",
  //   name: "Thrive Service plus Request",
  //   component: ThriveServicePlusRequest,
  // },

  // {
  //   path: "/dashboard/thrive-signature-request",
  //   name: "Thrive Signature Request",
  //   component: ThriveSignatureRequest,
  // },

  {
    path: "/dashboard/email-template-service",
    name: "Email Template Service",
    component: AutoEmailTemplate,
  },

  { path: "/dashboard/gepredirectionlinks", name: "GepRedirection Links", component: gepredirectionLinks },
  {
   path: "/dashboard/create-gepredirection-links",
   name: "Create GepRedirection",
   component: CreateGepRedirection,
 },

 {
   path: "/dashboard/view-gepredirection",
   name: "View GepRedirection",
   component: ViewGepRedirection,
 },
 {
    path: "/dashboard/signature-enrollments",
    name: "Signature Enrollments",
    component: SignatureEnrollments,
  },  
  {
    path: "/dashboard/signature-unenrollments",
    name: "Signature Unenrollments",
    component: SignatureUnEnrollments,
  }, 
  {
    path: "/dashboard/upload-target-account",
    name: "Upload Target Accounts",
    component: Upload,
  }, 
  {
    path: "/dashboard/target-accounts",
    name: "Target Accounts",
    component: TargetAccounts,
  },
  {
    path: "/dashboard/google-analyst",
    name: "Dashboard Analytics",
    component: GoogleAnalyst,
  },

  {
    path: "/dashboard/thrive-startup-enrollments",
    name: "Thrive StartUp Enrollments",
    component: ThriveStartUpEnrollments,
  },
  {
    path: "/dashboard/manage-startup-accounts",
    name: "Manage Startup Accounts",
    component: StartupTab,
  },
  {
    path: "/dashboard/startup-unenrollments",
    name: "Startup Unenrollments",
    component: StartupUnEnrollments,
  },
  {
      path: "/dashboard/audit-startup",
      name: "Audit Startup",
      component: StartupAudit
    },
    {
  path: "/dashboard/manage-unlock-accounts",
  name: "Manage Unlock Accounts",
  component: UnlockShiptoManagement
},
{
  path: "/dashboard/unlock-edit-shipto",
  name: "Edit Shipto",
  component: EditShiptoPage
},
{
  path: "/dashboard/unlock-create-shipto",
  name: "Create Shipto",
  component: create  
},
{
  path: "/dashboard/unlock-create-details",
  name: "Create Details",
  component: createDetails 
},
{
  path: "/dashboard/unlock-upload-shipto",
  name: "Upload Shipto",
  component: UploadShipto
},
{
  path: "/dashboard/unlock-shipto-result",
  name: "Failed Shipto",
  component: UnlockShiptoUploadResult
},{
  path: "/dashboard/unlock-milestone-tracking",
  name: "Unlock MileStone Tracking",
  component: MilestoneTracking
},
{
  path: "/dashboard/unlock-milestone-view",
  name: "MileStone Tracking View",
  component: GrowthBonusDashboard
},
{
  path: "/dashboard/milestonecriteria",
  name: "Milestone Criteria",
  component: MilestonePromotion,
},
{
  path: "/dashboard/create-milestone-criteria",
  name: "Create Milestone Criteria",
  component: milestoneCriteriaCreate,
},
{
  path: "/dashboard/view-milestone-criteria",
  name: "View Milestone Criteria",
  component: milestoneCriteriaView,
},

{
    path: "/dashboard/update-plan-history",
    name: "View Plan",
    component: ViewPlan,
  },
{
  path: "/dashboard/stacking-promotion",
  name: "Stacking Promotion",
  component: StackingPromotion,
},
{
  path: "/dashboard/create-stack-promo",
  name: "Create Stacking Promotion",
  component: CreateStackingPromotion  
},
{
  path: "/dashboard/edit-stack-promo",
  name: "Edit Stacking Promotion",
  component: EditStackingPromotion  
},
{
  path: "/dashboard/growth-bonus",
  name: "Unlock Customer View",
  component: UnlockCustomerView  
},

{
  path: "/dashboard/thrive-campaign",
  name: "Thrive Campaign",
  component: ThriveCampaign 
},
{
  path: "/dashboard/promo-code-creation",
  name: "Promo Code Creation",
  component: PromoCodeCreation  
},
];

export default dashboardRoutes;
